import { actionCreatorFactory } from 'typescript-fsa'
import { User } from '../../types'

const actionCreator = actionCreatorFactory()

export const receiveUser = actionCreator<User>('receiveUser')
export const removeUser = actionCreator<{ id: string }>('removeUser')
